// store/highlightSlice.ts
import { createSlice } from "@reduxjs/toolkit";

const highlightSlice = createSlice({
  name: "highlight",
  initialState: {
    downloadHighlighted: false,
    uploadHighlighted: false,
  },
  reducers: {
    setHighlight: (state, action) => {
      state.downloadHighlighted = action.payload;
    },
    setUploadHighlight: (state, action) => {
      state.uploadHighlighted = action.payload;
    },
  },
});

export const { setHighlight, setUploadHighlight } = highlightSlice.actions;

export default highlightSlice.reducer;
